import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'timeFormat',
  standalone: true
})
export class TimeFormatPipe implements PipeTransform {
  transform(time: string | number): string {
    if (typeof time === 'number') {
      // If it's a timestamp, convert to Date and format
      const date = new Date(time);
      return date.toLocaleTimeString('en-US', {
        hour: 'numeric',
        minute: '2-digit',
        hour12: true
      });
    }
    
    if (typeof time === 'string') {
      // If it's already a formatted string, return as is
      if (time.includes('AM') || time.includes('PM')) {
        return time;
      }
      
      // If it's in HH:MM:SS format, convert to 12-hour format
      const timeParts = time.split(':');
      if (timeParts.length >= 2) {
        const hours = Number.parseInt(timeParts[0]);
        const minutes = timeParts[1];
        
        if (hours === 0) {
          return `12:${minutes} AM`;
        } else if (hours < 12) {
          return `${hours}:${minutes} AM`;
        } else if (hours === 12) {
          return `12:${minutes} PM`;
        } else {
          return `${hours - 12}:${minutes} PM`;
        }
      }
    }
    
    return time.toString();
  }
}
